/**
 * Volvo Operations Portal - Main Application
 */
// Import Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
// Import Bootstrap Icons CSS (local)
import 'bootstrap-icons/font/bootstrap-icons.css';
// Import custom styles
import '../scss/main.scss';
// Import Bootstrap JS
import * as bootstrap from 'bootstrap';
// Import jQuery and DataTables
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-responsive-bs5';
// Make jQuery and DataTables available globally FIRST
window.jQuery = $;
window.$ = $;
// Import Select2
import 'select2';
import 'select2/dist/css/select2.min.css';
import { ThemeManager } from './modules/app/ThemeManager';
import { AlertManager } from './modules/app/AlertManager';
import { FormValidator } from './modules/app/FormValidator';
import { SidebarManager } from './modules/app/SidebarManager';
import { SessionTimeoutManager } from './modules/app/SessionTimeoutManager';
import { LogViewer } from './modules/app/LogViewer';
import { ValidationModalManager } from './modules/app/ValidationModalManager';
import { InvoicesReceived } from './modules/db/invoices_received/InvoicesReceived';
import { AdvancedSearch } from './modules/db/invoices_received/AdvancedSearch';
import { Profiles } from './modules/db/profiles/Profiles';
import { ProfilesForm } from './modules/db/profiles/ProfilesForm';
import { Suppliers } from './modules/db/suppliers/Suppliers';
import { SuppliersForm } from './modules/db/suppliers/SuppliersForm';
import { Users } from './modules/db/users/Users';
import { UsersForm } from './modules/db/users/UsersForm';
import { UserActions } from './modules/db/users/UserActions';
import { Permissions } from './modules/db/permissions/Permissions';
import { PermissionsForm } from './modules/db/permissions/PermissionsForm';
import { ValidationMessages } from './modules/db/validation_messages/ValidationMessages';
import { ValidationMessagesForm } from './modules/db/validation_messages/ValidationMessagesForm';
import { PaymentsComplementsVendorTxt } from './modules/db/payments_complements_vendor_txt/PaymentsComplementsVendorTxt';
import { TxtReportForm } from './modules/db/txt_report/TxtReportForm';
class App {
    constructor() {
        this.themeManager = new ThemeManager();
        this.alertManager = new AlertManager();
        this.formValidator = new FormValidator();
        this.sidebarManager = new SidebarManager();
        this.sessionTimeoutManager = new SessionTimeoutManager();
    }
    init() {
        // Initialize theme manager
        this.themeManager.init();
        // Initialize alert manager
        this.alertManager.init();
        // Initialize form validator
        this.formValidator.init();
        // Initialize sidebar manager
        this.sidebarManager.init();
        // Initialize session timeout manager
        this.sessionTimeoutManager.init();
        // Setup global event listeners
        this.setupEventListeners();
    }
    setupEventListeners() {
        // Handle AJAX CSRF token
        this.setupCSRFProtection();
        // Handle document ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this.onDOMReady();
            });
        }
        else {
            this.onDOMReady();
        }
    }
    onDOMReady() {
        // Initialize Bootstrap tooltips
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        tooltipTriggerList.forEach((tooltipTriggerEl) => {
            new bootstrap.Tooltip(tooltipTriggerEl);
        });
        // Initialize Bootstrap popovers
        const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
        popoverTriggerList.forEach((popoverTriggerEl) => {
            new bootstrap.Popover(popoverTriggerEl);
        });
        // Initialize page-specific modules
        this.initializePageModules();
    }
    initializePageModules() {
        // Initialize ValidationModalManager if modal exists
        const validationModal = document.getElementById('validationMessagesModal');
        if (validationModal) {
            this.validationModalManager = new ValidationModalManager();
            this.validationModalManager.init();
        }
        // Initialize LogViewer module if logs container exists
        const logsContainer = document.getElementById('logsContainer');
        if (logsContainer) {
            this.logViewer = new LogViewer();
        }
        // Initialize InvoicesReceived module if table exists
        const invoicesTable = document.querySelector('#invoicesTable');
        if (invoicesTable) {
            this.invoicesReceived = new InvoicesReceived();
        }
        // Initialize AdvancedSearch module if form exists
        const advancedSearchForm = document.querySelector('#advancedSearchForm');
        if (advancedSearchForm) {
            this.advancedSearch = new AdvancedSearch();
        }
        // Initialize Profiles module if table exists
        const profilesTable = document.querySelector('#profilesTable');
        if (profilesTable) {
            this.profiles = new Profiles();
        }
        // Initialize ProfilesForm module if form exists
        const profileForm = document.getElementById('profileForm');
        if (profileForm) {
            this.profilesForm = new ProfilesForm();
        }
        // Initialize Suppliers module if table exists
        const suppliersTable = document.querySelector('#suppliersTable');
        if (suppliersTable) {
            this.suppliers = new Suppliers();
        }
        // Initialize SuppliersForm module if form exists
        const supplierForm = document.getElementById('supplierForm');
        if (supplierForm) {
            this.suppliersForm = new SuppliersForm();
        }
        // Initialize Users module if table exists
        const usersTable = document.querySelector('#usersTable');
        if (usersTable) {
            this.users = new Users();
        }
        // Initialize UsersForm module if form exists
        const userForm = document.getElementById('userForm');
        if (userForm) {
            this.usersForm = new UsersForm();
        }
        // Initialize UserActions module if table exists
        const userActionsTable = document.querySelector('#userActionsTable');
        if (userActionsTable) {
            this.userActions = new UserActions();
        }
        // Initialize Permissions module if table exists
        const permissionsTable = document.querySelector('#permissionsTable');
        if (permissionsTable) {
            this.permissions = new Permissions();
        }
        // Initialize PermissionsForm module if form exists
        const permissionForm = document.getElementById('permissionForm');
        if (permissionForm) {
            this.permissionsForm = new PermissionsForm();
        }
        // Initialize ValidationMessages module if table exists
        const validationMessagesTable = document.querySelector('#validationMessagesTable');
        if (validationMessagesTable) {
            this.validationMessages = new ValidationMessages();
        }
        // Initialize ValidationMessagesForm module if form exists
        const validationMessageForm = document.getElementById('validationMessageForm');
        if (validationMessageForm) {
            this.validationMessagesForm = new ValidationMessagesForm();
        }
        const paymentsTable = document.querySelector('#paymentsTable');
        if (paymentsTable) {
            this.paymentsComplementsVendorTxt = new PaymentsComplementsVendorTxt();
        }
        // Initialize TxtReportForm module if form exists
        const txtReportForm = document.getElementById('txtReportForm');
        if (txtReportForm) {
            this.txtReportForm = new TxtReportForm();
        }
    }
    setupCSRFProtection() {
        // Get CSRF token from meta tag
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
        const csrfCookieName = document.querySelector('meta[name="csrf-cookie-name"]')?.getAttribute('content');
        if (csrfToken) {
            // Add CSRF token to all fetch requests
            const originalFetch = window.fetch;
            window.fetch = function (input, init) {
                init = init || {};
                init.headers = init.headers || {};
                if (init.headers instanceof Headers) {
                    init.headers.set('X-CSRF-TOKEN', csrfToken);
                }
                else {
                    init.headers['X-CSRF-TOKEN'] = csrfToken;
                }
                return originalFetch(input, init);
            };
        }
    }
    // Expose bootstrap globally for external scripts if needed
    static getBootstrap() {
        return window.bootstrap || bootstrap;
    }
}
// Make bootstrap available globally for backward compatibility
window.bootstrap = bootstrap;
// Initialize app when DOM is ready
const app = new App();
app.init();
export default app;
